var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportToFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4631 4V3.56509C15.4643 3.46565 15.4235 3.37022 15.3506 3.30259L12.7782 0.730002C12.7104 0.657179 12.6152 0.616332 12.5157 0.617502H2.23299C2.0259 0.617502 1.85799 0.785416 1.85799 0.992502V4.53479H2.60799V1.3675H11.8253V4.00004C11.8253 4.09949 11.8648 4.19491 11.9351 4.26522C12.0054 4.33553 12.1009 4.37504 12.2003 4.37504H14.7128V18.6328H2.59278V15.4655H1.84277V19.0005C1.84277 19.0999 1.88228 19.1953 1.9526 19.2656C2.02307 19.336 2.11833 19.3755 2.21777 19.3755H15.0878C15.1872 19.3755 15.2827 19.336 15.353 19.2656C15.4233 19.1953 15.4628 19.0999 15.4628 19.0005L15.4631 4ZM12.5756 1.58492L14.5856 3.59483L12.5756 3.595V1.58492Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3117 13.9932L3.65186 13.3334L6.45186 10.5334L3.65186 7.73336L4.3117 7.07352L7.44217 10.203V10.8638L4.3117 13.9932Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0668H6.53317V11.0001H0V10.0668Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportToFile);
export default __webpack_public_path__ + "static/media/export-to-file.e262d589c3304930bc25718965782f47.svg";
export { ForwardRef as ReactComponent };